import { gql } from "@apollo/client";

/** Voice messages eligible to link on activity create (not already linked to an activity). */
export const GET_LINKABLE_VOICE_MESSAGES_QUERY = gql`
  query GetLinkableVoiceMessages($data: VoiceMessageQuery!) {
    voiceMessages(data: $data) {
      data {
        id
        title
      }
    }
  }
`;
